module.exports = __webpack_public_path__ + "static/media/Discord.33a5aa61.svg";